<template>
  <main class="relative grow flex flex-col">
    <div class="light-grid absolute inset-0 bg-grid-slate-100 [mask-image:linear-gradient(0deg,#fff,rgba(255,255,255,0.6))]" style="background-position: 10px 10px;"></div>

    <div class="absolute"><slot></slot></div>
    <div class="shrink-0 p-4 flex justify-between items-start relative z-10">
      <div class="grow">
        <slot name="top-left-content"></slot>
      </div>
      <div class="flex grow justify-end space-x-2">
        <button
          v-if="ready"

          type="button"
          class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm rounded-lg text-gray-600 hover:bg-gray-50 duration-150 outline-none active:ring-2 active:ring-offset-2 ring-blue-500 space-x-2 font-bold"
          @click="setFullscreen"
          @mouseover="willChange = true"
          @mouseleave="willChange = false"
        >
          <span>Fullscreen preview</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M3 4a1 1 0 011-1h4a1 1 0 010 2H6.414l2.293 2.293a1 1 0 01-1.414 1.414L5 6.414V8a1 1 0 01-2 0V4zm9 1a1 1 0 110-2h4a1 1 0 011 1v4a1 1 0 11-2 0V6.414l-2.293 2.293a1 1 0 11-1.414-1.414L13.586 5H12zm-9 7a1 1 0 112 0v1.586l2.293-2.293a1 1 0 011.414 1.414L6.414 15H8a1 1 0 110 2H4a1 1 0 01-1-1v-4zm13-1a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 110-2h1.586l-2.293-2.293a1 1 0 011.414-1.414L15 13.586V12a1 1 0 011-1z" clip-rule="evenodd" />
          </svg>
        </button>
        <ResizerElement v-model="width"/>
<!--        <button type="button" class="inline-flex items-center px-2 py-2 border border-transparent text-sm rounded-md text-pink-700 bg-pink-100 hover:bg-pink-200 duration-150 outline-none ring-2 ring-offset-2 ring-pink-500 space-x-2 font-bold" @click="$emit('toggle-color-swatch')">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
          Style settings
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4 2a2 2 0 00-2 2v11a3 3 0 106 0V4a2 2 0 00-2-2H4zm1 14a1 1 0 100-2 1 1 0 000 2zm5-1.757l4.9-4.9a2 2 0 000-2.828L13.485 5.1a2 2 0 00-2.828 0L10 5.757v8.486zM16 18H9.071l6-6H16a2 2 0 012 2v2a2 2 0 01-2 2z" clip-rule="evenodd" />
          </svg>
        </button>-->
      </div>
    </div>

    <div class="flex justify-center grow pb-5">
      <div class="relative">
        <div
          class="border border-gray-200 overflow-hidden rounded-lg bg-white relative w-[1500px] h-full duration-200 ease-in-out"
          :class="[
            prepareAnimation && '!fixed z-40',
            animate && '!left-0 !top-0 !w-full !h-full rounded-none'
          ]"

          :style="{
            'will-change': willChange ? 'left, top, width: scaledWidth, height' : '',
            width: scaledWidth + 'px',
            ...(prepareAnimation && {
              left: `${prepareAnimation.left}px`,
              top: `${prepareAnimation.top}px`,
              width: `${prepareAnimation.width}px`,
              height: `${prepareAnimation.height}px`,
            }) || {},
          }"
          @mouseleave.self="$store.commit('editor/blockHover', null)"
        >
          <iframe
            v-if="renderingIframe" class="h-full !w-full"

            :width="scaledWidth"
            height="800"
            :src="iframeSrc"

            loading="eager"
            ref="iframe"
            id="iframe"
          ></iframe>

          <transition name="fade">
            <div v-if="(!ready || error) && !productionView" class="absolute w-full h-full left-0 top-0 bg-white flex justify-center items-center flex-col">
              <template v-if="!error">
                <svg class="text-primary animate-spin w-16" width="60" height="60" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle style="opacity: .25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path style="opacity: .75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <h2 class="font-bold mt-3 text-xl">
                  {{ !iframeTarget ? "Fetching website.." : (!magentoLoaded ? 'Preparing editor...' : 'Rendering blocks...') }}
                </h2>

                <div class="flex space-x-2 mt-4">
                  <span class="w-12 h-3 bg-gray-100 rounded border border-gray-200 duration-150" :class="iframeTarget && '!bg-primary !border-primary'"></span>
                  <span class="w-12 h-3 bg-gray-100 rounded border border-gray-200 duration-150" :class="magentoLoaded && '!bg-primary !border-primary'"></span>
                  <span class="w-12 h-3 bg-gray-100 rounded border border-gray-200 duration-150" :class="contentRendered && '!bg-primary !border-primary'"></span>
                </div>
              </template>
              <template v-else>
                <svg xmlns="http://www.w3.org/2000/svg" class="text-red-600" width="60" height="60" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>

                <h2 class="font-bold mt-2 text-xl">
                  Er is een fout opgetreden bij het laden van de website.
                </h2>
                <p>
                  Het is mogelijk niet goed ingesteld.
                </p>
              </template>
            </div>
          </transition>

          <div class="shadow-inner absolute z-10 bg-transparent rounded-lg pointer-events-none left-0 top-0 w-full h-full"></div>
        </div>
      </div>
    </div>

    <transition
      enter-class="mt-2 opacity-0"
      leave-class="mt-0 opacity-100"
      enter-to-class="mt-0 opacity-100"
      leave-to-class="mt-2 opacity-0"
    >
      <div
        v-if="animate"
        class="duration-200 fixed bottom-0 right-0 mr-24 mb-8 z-40 space-x-2"

        @mouseover="willChange = true"
        @mouseleave="willChange = false"
      >
<!--        <span class="relative z-0 inline-flex shadow-sm rounded-md translate-y-[3px] cursor-pointer group" @click="toggleProductionMode">
          <span class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white group-hover:bg-gray-50">
            <input id="select-all" type="checkbox" :checked="productionView" name="select-all" class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
          </span>
          <span class="px-2 py-2 border-l-0 border border-gray-300 rounded-r-md group-hover:bg-gray-50 font-semibold text-gray-700">
            Production view
          </span>
        </span>-->
        <button type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="deanimate">
          <span>Back to editor</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </button>
      </div>
    </transition>

  </main>
</template>

<script>

import { mapGetters } from 'vuex'

import ResizerElement from './ContentOptions/ResizerElement.vue'

import { clone } from "@/utils/editor"

export default {
  props: ['iframeTarget'],
  components: {
    ResizerElement,
  },
  data() {
    let width = 1380
    try {
      width = localStorage.getItem('width') ? parseInt(localStorage.getItem('width'), 10) : 1380
    } catch (err) {
      width = 1380
    }

    return {
      width,
      swatch: false,

      contentRendered: false,
      updateMagentoOnce: false,

      hasUpdate: true,
      error: false,
      preventMagentoUpdate: false,
      showingIframe: true,
      needsToRefetch: false,

      prepareAnimation: null,
      animate: false,
      willChange: false,
      productionView: false,
    }
  },
  created() {
    if (this.ready) this.$store.commit("editor/restart")
    this.timeout = setTimeout(() => {
      this.error = true
    }, 35000)

    window.addEventListener("message", evt => {
      if (evt.origin !== this.domain) return;

      switch (evt.data.event) {
        case "request-update": {
          console.log("trigger -updates")
          this.triggerUpdates()

          break
        }
        case "clicked-event": {
          this.$store.commit("editor/iframeClick")
          break
        }
        case "request-context": {
          this.saveContainerWidth(evt.data.data, true)
          // component: "ImageManager",
          // bind: evt.data.data,
          break
        }
        case "block-hover": {
          this.$store.commit('editor/blockHover', evt.data.data)

          break
        }
        case "reloaded-block": {
          this.$store.dispatch("editor/reloadedBlock", evt.data.data)
          break
        }
        case "magento-content-loaded": {
          this.loadData()
          clearTimeout(this.timeout)
          this.error = false
          this.$store.commit("editor/magentoLoaded")
          this.updateMagento()

          break
        }
        case "magento-config-rendered": {
          this.contentRendered = true
          requestAnimationFrame(() => this.$store.commit("editor/ready", evt.data.data))

          break
        }
        case "overwritten-tailwind": {
          this.$store.commit("editor/triggerMagentoOverwrite", null)

          break
        }
        case "refetched": {
          this.needsToRefetch = false

          break
        }
        case "update-content": {
          const { blockId, role, content, keysToRemove, allowReactiveUpdateFromEditor } = evt.data.data
          // if (!allowReactiveUpdateFromEditor)
          this.preventMagentoUpdate = true

          /*
            blockId: "BasicFooter"
            content: {}
            keysToRemove: undefined
            role: "footer"
          * */

          this.$store.dispatch("editor/overwriteBlockContent", { id: blockId, role, content })

          if (!keysToRemove) return;

          const index = this.config.blocks_collection[this.page][role].findIndex(item => item.id === blockId)
          if (index < 0) return;
          this.$store.dispatch(
            "editor/removeConfigKeys",
            keysToRemove.map(key => `blocks_collection.${this.page}.${role}.${index}.content.${key}`)
          )

          break
        }
      }
    })
  },
  beforeDestroy() {
    this.interval && clearInterval(this.interval)
    this.interval = null
  },
  methods: {
    deanimate() {
      this.animate = false
      this.productionView = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.animate = false
          this.prepareAnimation = null
        }, 325)
      })
    },
    setFullscreen() {
      const { left, top, width, height } = this.$refs.iframe.getBoundingClientRect()
      this.productionView = true
      this.prepareAnimation = { left, top, width, height }
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.animate = true
        })
      })
    },
    restart() {
      this.showingIframe = false
      this.contentRendered = false
      this.$nextTick(() => {
        this.showingIframe = true
      })
    },
    loadData() {
      this.getWebsiteImages()
      this.loadCategories()
    },
    async getWebsiteImages() {
      const {results} = (await this.axios.get(`/api/websites/${this.website.uid}/files`, {params: {page_size: 50}})).data
      this.sendDynamicData({ availableImages: results.map(item => item.url) })
    },
    async loadCategories() {
      // const categories = (await this.axios.get(`${this.domain}/rest/V1/editor/list-available-categories`)).data
      this.categories = (await this.$store.dispatch("cachedGet", {
        endpoint: `${this.link}/rest/V1/editor/list-available-categories`,
        headers: { Cookie: 'environment=editor' },
      })).data || []
      this.sendDynamicData({ categories: this.categories })
    },
    sendDynamicData(data) {
      data.__dynamic = true
      this.$refs.iframe && this.$refs.iframe.contentWindow.postMessage(data, "*")
    },
    triggerUpdates(force) {
      if (force) return this.updateMagento()

      this.hasUpdate = true
      if (this.interval || !this.ready || !this.config) return;
      this.interval = setInterval(() => {
        if (this.preventMagentoUpdate) {
          this.preventMagentoUpdate = false
          return this.hasUpdate = false
        }
        if (this.ready && (this.hasUpdate || !this.updateMagentoOnce)) {
          this.updateMagento()
          this.hasUpdate = false
          this.updateMagentoOnce = true
        }
      }, 50)
    },
    updateMagento() {
      console.log("PAGE_CONTAINERS; ", this.pageContainers)
      const obj = {
        ...this.config,
        blocks_collection: this.pageContainers || {},
        needsToRefetch: this.needsToRefetch ? (this.specificBlockToRefetch || true) : null,
        blockReload: this.blockReload,
        context: this.context,
        states: this.states,
      }
      console.log('before magento update: ', clone(obj))
      this.$refs.iframe && this.$refs.iframe.contentWindow.postMessage(obj, "*")
    },
    saveContainerWidth(options, noTimeout) {
      const openDropdown = () => {
        requestAnimationFrame(() => {
          let width, height, left, top
          if (this.$refs.iframe) {
            const rect = this.$refs.iframe.getBoundingClientRect()

            width = rect.width
            height = rect.height
            left = rect.left
            top = rect.top
          }
          this.$store.commit("editor/triggerContainerOptions", {
            iframeRect: { width, height, left, top },
            ...options,
          })
        })
      }

      if (noTimeout) openDropdown()
      else setTimeout(() => openDropdown(), 200)
    },
  },
  computed: {
    ...mapGetters({
      ready: 'editor/ready',
      website: 'editor/website',
      page: 'editor/page',
      magentoLoaded: 'editor/magentoLoaded',
      restartTrigger: 'editor/restartTrigger',
      config: 'editor/config',
      domain: 'editor/fullDomainLink',
      pageContainers: 'editor/pageContainers',
      encodedTailwindConfig: 'editor/encodedTailwindConfig',
      triggerBlocksRefetch: 'editor/triggerBlocksRefetch',
      blockReload: 'editor/blockReload',
      stringifiedConfig: 'editor/stringifiedConfig',
      specificBlockToRefetch: 'editor/specificBlockToRefetch',
      context: 'editor/context',
      states: 'editor/states',
    }),

    scaledWidth() {
      return this.width / 1.33333333333
    },
    iframeSrc() {
      const link = (this.iframeTarget + this.previewStr)
      if (!link) return null
      return link.replace(/\/\/+/g, "/").replace("https:/", "https://")
    },
    previewStr() {
      const target = this.iframeTarget

      if (!target) return;
      return target.includes("?") ? '&preview=true' : '?preview=true'
    },
    renderingIframe() {
      return this.iframeTarget && this.showingIframe
    },
  },
  watch: {
    iframeSrc(val, old) {
      console.warn("should not ever change!", val, old)
    },
    renderingIframe(val) {
      console.warn("SOHULD NOT BE HAPPENING!, ", val)
      val && this.saveContainerWidth()
    },
    width(width) {
      console.warn("changed width!")
      localStorage.setItem('width', width)
      this.saveContainerWidth()
    },
    productionView() {
      this.$store.commit("editor/closeContainerOptions")
    },
    page() {
      this.$store.commit("editor/restart")
    },
    iframeTarget() {
      this.$store.commit("editor/restart")
    },
    triggerBlocksRefetch() {
      this.needsToRefetch = true
      this.triggerUpdates()
    },
    blockReload() {
      this.triggerUpdates()
    },
    magentoLoaded(val) {
      val && this.triggerUpdates(true)
    },
    ready(val) {
      val && requestAnimationFrame(() => this.triggerUpdates())
    },
    config: {
      handler() {
        this.triggerUpdates()
      },
      deep: true,
    },
    magentoOverwriteTrigger(val) {
      val && this.triggerUpdates()
    },
    restartTrigger() {
      this.restart()
    },
  },
}

</script>
